export default class NormalType {
  type;
  description;

  constructor(type, description = '') {
    this.type = type;
    this.description = description;
  }

  setType(type) {
    this.type = type;
  }

  getType() {
    return this.type;
  }

  setDescription(description) {
    this.description = description;
  }

  getDescription() {
    return this.description;
  }
}
